import React from 'react';
import { format0 } from 'utils/number';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { Checkbox } from '@carbon/react';
import { ColorSwatch, hexToRgba } from 'components/color-picker';
import { setDatasetVisibleAtom } from '../atoms';
import { useDatasetConfig, useDatasetAtoms } from '../dataset-context';
import style from 'components/map/map.module.scss';
import styles from './scoped-layer-selection.module.scss';

const ScopedLayerSelection = () => {
  const config = useDatasetConfig();
  const atoms = useDatasetAtoms();
  const visible = useAtomValue(atoms.scopedLayerVisibleAtom);
  const setDatasetVisible = useSetAtom(setDatasetVisibleAtom);
  const [color, setColor] = useAtom(atoms.layerColorAtom);
  const { data } = useAtomValue(atoms.searchAtom);

  const label =
    data?.totalCount !== undefined
      ? `${config.label} Query Results (${format0(data.totalCount)})`
      : `${config.label} Query Results`;

  return (
    <div className={style.groupChecks}>
      <div className={styles.scopedLayer}>
        <ColorSwatch
          color={color}
          onChange={(newColor, newOpacity) =>
            setColor(hexToRgba(newColor, newOpacity))
          }
        />
        <Checkbox
          id={`scoped-query-results-${config.id}`}
          labelText={label}
          checked={visible}
          onChange={(
            _evt: React.ChangeEvent<HTMLInputElement>,
            { checked }: { checked: boolean }
          ) => setDatasetVisible({ datasetId: config.id, visible: checked })}
        />
      </div>
      {config.layerNote && <p className={styles.note}>{config.layerNote}</p>}
    </div>
  );
};

export { ScopedLayerSelection };
